var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.isAccepted ? "border border-success" : "border-primary",
        "card bg-light col-sm-4 mb-4 mr-4"
      ]
    },
    [
      _c(
        "div",
        { staticClass: "card-body d-flex flex-column" },
        [
          _c("h5", { staticClass: "card-title text-center" }, [
            _vm._v("\n      " + _vm._s(_vm.documentTitle) + "\n      "),
            _vm.isAccepted
              ? _c(
                  "span",
                  { staticClass: "badge badge-success float-right" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["far", "check"] }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.needsUpload
              ? _c(
                  "span",
                  { staticClass: "badge badge-primary float-right" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fad", "exclamation"] }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "card-text font-weight-light d-inline-flex justify-content-center mt-auto"
            },
            [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.isAccepted
            ? [
                _c(
                  "div",
                  {
                    staticClass: "d-inline-flex justify-content-center mt-auto"
                  },
                  [
                    _c(
                      "ehr-button",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          "button-type-class": "btn-success",
                          loading: _vm.isLoading,
                          disabled: true,
                          icon: "check",
                          "is-duotone": false
                        }
                      },
                      [
                        _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v("Upload voltooid")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-inline-flex justify-content-center mt-auto"
                  },
                  [
                    _c("file-list", {
                      staticClass: "text-left mb-0",
                      attrs: { label: "Bestanden:", files: _vm.testFiles }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.needsUpload
            ? [
                _c("file-upload", {
                  staticClass: "mt-auto",
                  attrs: { label: "Bestand uploaden:", "upload-percentage": 0 },
                  on: { "files-changed": _vm.onFilesChanged }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }